import React, { useState } from "react";
import i18n from "src/i18n";
import moment from "moment";
import { Icon, Button, Input } from "semantic-ui-react";
import {
  findFamilyLabel,
  findTypeLabel,
} from "../general/js/forms/crearObligacion/functions";
import BankSelection from "../general/js/formTypes/bankSelection";
import { formatMoney, formatRut, rutWithDash } from "../../utils/formatter";
import "./nuevaTablaDocumentos.scss";

export const ModalForm = (type, data) => {
  const [abono, setAbono] = useState({
    tercero: {
      0: {
        amount: String(data.meta.remaining),
        paymentDate: moment().format("YYYY-MM-DD"),
      },
    },
    tarjeta: {
      0: {
        amount: String(data.meta.remaining),
        paymentDate: moment().format("YYYY-MM-DD"),
      },
    },
    factoring: {
      0: {
        amount: String(data.meta.remaining),
        paymentDate: moment().format("YYYY-MM-DD"),
      },
    },
    parcial: {
      0: {
        amount: String(data.meta.remaining),
        paymentDate: moment().format("YYYY-MM-DD"),
      },
    },
    cheque: {
      0: {
        amount: String(data.meta.remaining),
        paymentDate: moment().format("YYYY-MM-DD"),
      },
    },
  });

  const [chequeCount, setChequeCount] = useState(0);

  if (type === "cheque") {
    const onDelete = (id) => {
      setAbono(() => {
        delete abono[type][id];
        return abono;
      });
      setChequeCount(chequeCount - 1);
    };

    const NewCheque = (id, hideDelete) => {
      return (
        <div className={`d-flex w-100`} id={id} key={id}>
          <div className="d-flex flex-column w-100 chequeNumber">
            <label hidden={id > 0}>Número de Cheque</label>
            <Input
              placeholder="Número de cheque..."
              required
              value={
                abono[type]
                  ? abono[type][id]
                    ? abono[type][id]?.chequeNum
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [id]: { ...abono[type][id], chequeNum: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 chequeAmount">
            <label hidden={id > 0}>Monto</label>
            <Input
              placeholder="Monto..."
              icon="dollar"
              iconPosition="left"
              value={
                abono[type]
                  ? abono[type][id]
                    ? formatMoney(abono[type][id]?.amount)
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [id]: { ...abono[type][id], amount: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 chequeFechaPago">
            <label hidden={id > 0}>Fecha de Pago</label>
            <Input
              type="date"
              value={
                abono[type]
                  ? abono[type][id]
                    ? abono[type][id]?.paymentDate
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [id]: { ...abono[type][id], paymentDate: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div
            className="d-flex justify-content-center align-items-center ml-2 cursor-pointer chequeDelete"
            onClick={() => onDelete(id)}
            style={{
              visibility: hideDelete || id == 0 ? "hidden" : "visible",
              paddingBottom: id == 0 ? "0" : "24px",
              paddingTop: id == 0 ? "5px" : "0",
            }}
          >
            <Icon name="minus circle" color="grey" />
          </div>
        </div>
      );
    };
    const chequeList = [...Array(chequeCount + 1).keys()];
    const visual = (
      <div className="d-flex flex-column chequeContainer">
        <div className="chequeAdd">
          <div className="chequeList">
            {chequeList.map((num) => {
              const hideDelete = chequeList.length > num + 1;
              return NewCheque(num, hideDelete);
            })}
          </div>
          <Button
            type="button"
            onClick={() => {
              if (!abono[type]) {
                setAbono((abono[type] = { [chequeCount]: {} }));
                return setChequeCount(chequeCount + 1);
              }
              if (!abono[type][chequeCount + 1])
                setAbono({
                  ...abono,
                  [abono[type]]: { ...abono[type], [chequeCount + 1]: {} },
                });
              setChequeCount(chequeCount + 1);
            }}
            fluid
          >
            <Icon name="add circle" />
            Agregar cheque
          </Button>
        </div>
      </div>
    );

    return {
      info: abono,
      visual,
    };
  }

  if (type == "tercero") {
    const visual = (
      <div className="d-flex flex-column terceroContainer">
        <div className="d-flex w-100 terceroData">
          <div className="d-flex flex-column w-100 terceroAmount">
            <label>Monto</label>
            <Input
              placeholder="Monto..."
              icon="dollar"
              iconPosition="left"
              value={
                abono[type]
                  ? abono[type][0]
                    ? formatMoney(abono[type][0]?.amount)
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], amount: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 terceroRut">
            <label>Rut</label>
            <Input
              placeholder="Rut..."
              maxLength={12}
              value={
                abono[type]
                  ? abono[type][0]
                    ? formatRut(abono[type][0]["rut"])
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], rut: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 terceroName">
            <label>Nombre</label>
            <Input
              placeholder="Nombre..."
              value={
                abono[type]
                  ? abono[type][0]
                    ? abono[type][0]["name"]
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], name: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 terceroDate">
            <label>Fecha de Pago</label>
            <Input
              type="date"
              value={
                abono[type]
                  ? abono[type][0]
                    ? abono[type][0]["paymentDate"]
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], paymentDate: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
        </div>
        <div className="w-100">
          <label>Observaciones</label>
          <Input
            placeholder="Observaciones..."
            value={abono[type] ? abono[type][0]["observations"] : ""}
            onChange={({ target }) =>
              setAbono({
                ...abono,
                ...{
                  [type]: {
                    ...abono[type],
                    [0]: { ...abono[type][0], observations: target.value },
                  },
                },
              })
            }
            fluid
          />
        </div>
      </div>
    );

    return {
      info: abono,
      visual,
    };
  }

  if (type == "tarjeta") {
    const visual = (
      <div className="d-flex flex-column tarjetaContainer">
        <div className="d-flex w-100 tarjetaData">
          <div className="d-flex flex-column w-100 tarjetaAmount">
            <label>Monto</label>
            <Input
              placeholder="Monto..."
              icon="dollar"
              iconPosition="left"
              value={
                abono[type]
                  ? abono[type][0]
                    ? formatMoney(abono[type][0]?.amount)
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], amount: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 tarjetaRut">
            <label>Banco</label>
            <BankSelection
              onChange={(_, target) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], bank: target.value },
                    },
                  },
                })
              }
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 tarjetaName">
            <label>Número de Tarjeta</label>
            <Input
              placeholder="Número de tarjeta..."
              value={
                abono[type]
                  ? abono[type][0]
                    ? abono[type][0]?.number
                    : ""
                  : ""
              }
              onChange={(_, target) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], number: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 tarjetaDate">
            <label>Fecha de Pago</label>
            <Input
              type="date"
              value={
                abono[type]
                  ? abono[type][0]
                    ? abono[type][0]?.paymentDate
                    : ""
                  : ""
              }
              onChange={(_, target) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], paymentDate: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
        </div>
        <div className="w-100">
          <label>Observaciones</label>
          <Input
            placeholder="Observaciones..."
            value={
              abono[type]
                ? abono[type][0]
                  ? abono[type][0]?.observations
                  : ""
                : ""
            }
            onChange={(_, target) =>
              setAbono({
                ...abono,
                ...{
                  [type]: {
                    ...abono[type],
                    [0]: { ...abono[type][0], observations: target.value },
                  },
                },
              })
            }
            fluid
          />
        </div>
      </div>
    );

    return {
      info: abono,
      visual,
    };
  }

  if (type == "factoring") {
    const visual = (
      <div className="d-flex flex-column tarjetaContainer">
        <div className="d-flex w-100 factoringData">
          <div className="d-flex flex-column w-100 factoringAmount">
            <label>Monto</label>
            <Input
              placeholder="Monto..."
              icon="dollar"
              iconPosition="left"
              value={
                abono[type]
                  ? abono[type][0]
                    ? formatMoney(abono[type][0]?.amount)
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], amount: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 factoringName">
            <label>Nombre del Factoring</label>
            <Input
              placeholder="Nombre del Factoring..."
              value={
                abono[type] ? (abono[type][0] ? abono[type][0]?.name : "") : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], name: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 factoringDate">
            <label>Fecha de Pago</label>
            <Input
              type="date"
              value={
                abono[type]
                  ? abono[type][0]
                    ? abono[type][0]?.paymentDate
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], paymentDate: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
        </div>
        <div className="w-100">
          <label>Observaciones</label>
          <Input
            placeholder="Observaciones..."
            value={
              abono[type]
                ? abono[type][0]
                  ? abono[type][0]?.observations
                  : ""
                : ""
            }
            onChange={({ target }) =>
              setAbono({
                ...abono,
                ...{
                  [type]: {
                    ...abono[type],
                    [0]: { ...abono[type][0], observations: target.value },
                  },
                },
              })
            }
            fluid
          />
        </div>
      </div>
    );

    return {
      info: abono,
      visual,
    };
  }

  if (type == "parcial") {
    const visual = (
      <div className="d-flex flex-column parcialContainer">
        <div className="d-flex w-100 parcialData">
          <div className="d-flex flex-column w-100 parcialAmount">
            <label>Monto</label>
            <Input
              placeholder="Monto..."
              icon="dollar"
              iconPosition="left"
              value={
                abono[type]
                  ? abono[type][0]
                    ? formatMoney(abono[type][0]?.amount)
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], amount: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
          <div className="d-flex flex-column w-100 pl-3 parcialDate">
            <label>Fecha de Pago</label>
            <Input
              type="date"
              value={
                abono[type]
                  ? abono[type][0]
                    ? abono[type][0]?.paymentDate
                    : ""
                  : ""
              }
              onChange={({ target }) =>
                setAbono({
                  ...abono,
                  ...{
                    [type]: {
                      ...abono[type],
                      [0]: { ...abono[type][0], paymentDate: target.value },
                    },
                  },
                })
              }
              fluid
            />
          </div>
        </div>
        <div className="w-100">
          <label>Observaciones</label>
          <Input
            placeholder="Observaciones..."
            value={
              abono[type]
                ? abono[type][0]
                  ? abono[type][0]?.observations
                  : ""
                : ""
            }
            onChange={({ target }) =>
              setAbono({
                ...abono,
                ...{
                  [type]: {
                    ...abono[type],
                    [0]: { ...abono[type][0], observations: target.value },
                  },
                },
              })
            }
            fluid
          />
        </div>
      </div>
    );

    return {
      info: abono,
      visual,
    };
  }
};

export const checkComplete = (type, input) => {
  let requiredFields = [];

  if (type == "cheque") requiredFields = ["chequeNum", "amount", "paymentDate"];
  if (type == "tercero")
    requiredFields = ["name", "rut", "amount", "paymentDate"];
  if (type == "tarjeta")
    requiredFields = ["bank", "number", "amount", "paymentDate"];
  if (type == "factoring") requiredFields = ["name", "amount", "paymentDate"];
  if (type == "parcial") requiredFields = ["amount", "paymentDate"];

  const isOK = () =>
    Object.keys(input).every((row) => {
      const data = input[row];
      return requiredFields.every((field) => {
        if (!data[field]) return false;
        return true;
      });
    });

  return isOK();
};

export const parseObligation = async (
  { type, userInput, isReceived, documentPaymentDate },
  { companyId, amount, meta, cashflowArea, cashflowAreaId },
  number
) => {

  const OBLIGATION = {
    documentType: "OBLIGATION",
    amount: 0,
    documentDate: new Date(),
    companyId,
    currencyType: "CLP",
    isManual: true,
    meta: {
      date: new Date(),
      documentDate: new Date(),
      amount: 0,
      currency: "CLP",
      remaining: 0,
      isPaid: false,
      originalAmount: 0,
      taxRate: 0,
      issuerId: meta?.issuerId || "",
      issuerName: meta?.issuerName || "",
      receiverId: meta?.receiverId || "",
      receiverName: meta?.receiverName || "",
      paymentDate: null,
      isReceived,
      description: "",
    },
  };

  if ( cashflowArea?.id || cashflowAreaId) {
    OBLIGATION.cashflowAreaId = cashflowArea?.id || cashflowAreaId;
  }

  if (documentPaymentDate) {
    OBLIGATION.documentDate = documentPaymentDate;  
    OBLIGATION.meta.date = documentPaymentDate;
    OBLIGATION.meta.documentDate = documentPaymentDate;
  }

  if (["efectivo"].includes(type)) {
    OBLIGATION.amount = amount;
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "efectivo";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "efectivo"
    );
    OBLIGATION.meta.amount = amount;
    OBLIGATION.meta.originalAmount = amount;
    OBLIGATION.meta.remaining = 0;
    OBLIGATION.meta.isPaid = true;
    OBLIGATION.meta.description = `Pago en efectivo correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)}.`;
  }

  if (["parcial"].includes(type)) {
    OBLIGATION.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "efectivo";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "efectivo"
    );
    OBLIGATION.meta.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.originalAmount = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.remaining = 0;
    OBLIGATION.meta.isPaid = true;
    OBLIGATION.meta.description = `Pago parcial en efectivo correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)}.`;
  }

  if (["tercero"].includes(type)) {
    OBLIGATION.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "pago_por_un_tercero";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "pago_por_un_tercero"
    );
    OBLIGATION.meta.receiverId = isReceived
      ? OBLIGATION.meta.receiverId
      : rutWithDash(userInput.rut.replace(/[^0-9Kk]/g, "").toUpperCase());
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : userInput.name;
    OBLIGATION.meta.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.originalAmount = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.remaining = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.issuerName = isReceived
      ? userInput.name
      : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived
      ? rutWithDash(userInput.rut.replace(/[^0-9Kk]/g, "").toUpperCase())
      : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.description = userInput.observations;
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["tarjeta"].includes(type)) {
    OBLIGATION.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "pago_tarjeta_credito";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "pago_tarjeta_credito"
    );
    OBLIGATION.meta.receiverId = isReceived ? OBLIGATION.meta.receiverId : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : "";
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.issuerName = isReceived ? "" : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.originalAmount = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.remaining = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.description = userInput.observations;
    OBLIGATION.meta.bank = userInput.bank;
    OBLIGATION.meta.cardNumber = userInput.number;
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["factoring"].includes(type)) {
    OBLIGATION.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "factoring";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "factoring"
    );
    OBLIGATION.meta.receiverId = isReceived ? "" : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : userInput.name;
    OBLIGATION.meta.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.originalAmount = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.remaining = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.issuerName = isReceived
      ? userInput.name
      : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.description = userInput.observations;
    OBLIGATION.meta.isReceived = isReceived
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["cheque"].includes(type)) {
    OBLIGATION.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "cheque";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "cheque"
    );
    OBLIGATION.meta.receiverId = isReceived ? OBLIGATION.meta.receiverId : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : "";
    OBLIGATION.meta.description = `Pago en cheque correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)} (${number}).`;
    OBLIGATION.meta.amount = parseInt(userInput.amount.replace(/[^0-9]/g, ""));
    OBLIGATION.meta.originalAmount = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.remaining = parseInt(
      userInput.amount.replace(/[^0-9]/g, "")
    );
    OBLIGATION.meta.issuerName = isReceived ? "" : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.number = userInput.chequeNum;
    OBLIGATION.meta.isReceived = isReceived
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["diferencia_de_pago"].includes(type)) {

    const amount = parseInt(userInput.amount.toString().replace(/[^0-9]/g, ""))

    OBLIGATION.amount = amount;
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "diferencia_de_pago";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "diferencia_de_pago"
    );
    OBLIGATION.meta.receiverId = isReceived ? OBLIGATION.meta.receiverId : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : "";
    OBLIGATION.meta.description = `Diferencia de Pago correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)}.`;
    OBLIGATION.meta.amount = amount;
    OBLIGATION.meta.remaining = amount;
    OBLIGATION.meta.originalAmount = amount;
    OBLIGATION.meta.issuerName = isReceived ? "" : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.isPaid = false;
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["diferencia_de_tipo_de_cambio", "diferenciadetipodecambio"].includes(type)) {

    const amount = parseInt(userInput.amount.toString().replace(/[^0-9]/g, ""))

    OBLIGATION.amount = amount;
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "diferenciadetipodecambio";
    OBLIGATION.meta.typeLabel = findTypeLabel(
      "otros_pagos_mensuales",
      "diferenciadetipodecambio"
    ) || findTypeLabel(
      "otros_pagos_mensuales",
      "diferencia_de_tipo_de_cambio"
    ) || "Diferencia de Tipo de Cambio";
    OBLIGATION.meta.receiverId = isReceived ? OBLIGATION.meta.receiverId : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : "";
    OBLIGATION.meta.description = `Diferencia de Tipo de Cambio correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)}.`;
    OBLIGATION.meta.amount = amount;
    OBLIGATION.meta.remaining = amount;
    OBLIGATION.meta.originalAmount = amount;
    OBLIGATION.meta.issuerName = isReceived ? "" : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.isPaid = false;
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["comision_por_factoring"].includes(type)) {

    const amount = parseInt(userInput.amount.toString().replace(/[^0-9]/g, ""))

    OBLIGATION.amount = amount;
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "comision_por_factoring";
    OBLIGATION.meta.typeLabel = 'Comisión por Factoring'
    OBLIGATION.meta.receiverId = isReceived ? OBLIGATION.meta.receiverId : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : "";
    OBLIGATION.meta.description = `Comisión por factoring correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)}.`;
    OBLIGATION.meta.amount = amount;
    OBLIGATION.meta.remaining = amount;
    OBLIGATION.meta.originalAmount = amount;
    OBLIGATION.meta.issuerName = isReceived ? "" : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.isPaid = false;
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["comision_por_venta"].includes(type)) {

    const amount = parseInt(userInput.amount.toString().replace(/[^0-9]/g, ""))

    OBLIGATION.amount = amount;
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "comision_por_venta";
    OBLIGATION.meta.typeLabel = 'Comisión por Venta'
    OBLIGATION.meta.receiverId = isReceived ? OBLIGATION.meta.receiverId : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : "";
    OBLIGATION.meta.description = `Comisión por venta correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)}.`;
    OBLIGATION.meta.amount = amount;
    OBLIGATION.meta.remaining = amount;
    OBLIGATION.meta.originalAmount = amount;
    OBLIGATION.meta.issuerName = isReceived ? "" : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.isPaid = false;
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  if (["comision_bancaria"].includes(type)) {

    const amount = parseInt(userInput.amount.toString().replace(/[^0-9]/g, ""))

    OBLIGATION.amount = amount;
    OBLIGATION.meta.family = "otros_pagos_mensuales";
    OBLIGATION.meta.familyLabel = findFamilyLabel("otros_pagos_mensuales");
    OBLIGATION.meta.type = "comision_bancaria";
    OBLIGATION.meta.typeLabel = 'Comisión Bancaria'
    OBLIGATION.meta.receiverId = isReceived ? OBLIGATION.meta.receiverId : "";
    OBLIGATION.meta.receiverName = isReceived
      ? OBLIGATION.meta.receiverName
      : "";
    OBLIGATION.meta.description = `Comisión bancaria correspondiente al documento ${
      meta?.documentId || meta?.typeLabel || ''
    } por $${formatMoney(amount)}.`;
    OBLIGATION.meta.amount = amount;
    OBLIGATION.meta.remaining = amount;
    OBLIGATION.meta.originalAmount = amount;
    OBLIGATION.meta.issuerName = isReceived ? "" : OBLIGATION.meta.issuerName;
    OBLIGATION.meta.issuerId = isReceived ? "" : OBLIGATION.meta.issuerId;
    OBLIGATION.meta.isPaid = false;
    OBLIGATION.meta.refDocuments = [
      {
        documentId: meta.documentId ? String(meta.documentId) : null,
        documentCode: meta.documentCode ? String(meta.documentCode) : null,
      },
    ].filter(f => f.documentId)
  }

  return OBLIGATION;
};

export const convertJSONToInput = (json) =>
  json.map((row) => {
    return {
      id: row["Id"] !== undefined ? row["Id"] : "undefined",
      rut:
        row["Rut"] !== undefined
          ? typeof row["Rut"] === "string"
            ? row["Rut"].replace(/\./g, "").replace(/-/g, "")
            : row["Rut"].toString()
          : "undefined",
      razonSocial:
        row["Razón Social"] !== undefined ? row["Razón Social"] : "undefined",
      tipo: row["Tipo"] !== undefined ? row["Tipo"] : "undefined",
      folio: row["Folio"] !== undefined ? row["Folio"] : "undefined",
      recibido: row["Recibido"] !== undefined ? row["Recibido"] : "undefined",
      montoTotal:
        row["Monto Total"] !== undefined
          ? row["Monto Total"].toString()
          : "undefined",
      saldo: row["Saldo"] !== undefined ? row["Saldo"].toString() : "undefined",
      fechaEmision:
        row["Fecha de Emision"] !== undefined
          ? row["Fecha de Emision"].toString()
          : "undefined",
      pagado: row["Pagado"] === "X" || row["Pagado"] === "x" ? true : false,
    };
  });

export const validateFields = async (json, companyId, callback) => {
  let data = [];
  for (let i = 0; i < json.length; i++) {
    const element = json[i];
    if (element["id"] === "undefined")
      return { message: "Nombre", valido: false, fila: i + 2 };
    if (element["pagado"] == "undefined")
      return { message: "Rut", valido: false, fila: i + 2 };
    data.push({ id: element["id"], settle: element["pagado"] });
  }

  await callback({ data: { data } });

  return { valido: true };
};

export const saldarTaxDocument = async (
  dispatch,
  importAlertState,
  element,
  settleTaxDocument,
  documentsDic,
  moneyToNumber,
  importUpdateNeeded,
  { total }
) => {
  dispatch(
    importAlertState({
      content: `Estamos actualizando su información (${total} DTE)`,
      state: "loading",
      duration: 10,
    })
  );
  const id = element?.id;
  const result = await settleTaxDocument({
    id,
    input: {
      amount: element?.montoTotal,
      companyId: element?.companyId,
      currencyType: element?.currencyType,
      documentDate: element?.fechaEmision,
      documentType: element?.documentType,
      isManual: element?.isManual,
      meta: {
        documentCode: documentsDic[element?.tipo]?.name,
        documentId: element?.folio,
        dueDate: element?.dueDate,
        inform: {
          amountInform: element?.amountInform,
          informDate: element?.informDate,
          isInform: element?.isInform,
          remaining: element?.informRemaining,
        },
        isPaid: true,
        isReceived: element?.recibido,
        issuedAt: element?.issuedAt,
        issuerId: element?.rutEmisor,
        issuerName: element?.emisor,
        netAmount: element?.netAmount,
        originalAmount: element?.originalAmount,
        otherTaxes: element?.otherTaxes,
        paymentDate: moment().format(),
        receiverId: element?.rutReceptor,
        receiverName: element?.receptor,
        remaining: moneyToNumber(0),
        summary: element?.summary,
        taxAmount: element?.taxAmount,
        taxRate: parseFloat(element?.taxRate),
      },
    },
  });
  if (result?.data) {
    dispatch(
      importAlertState({
        content: "Datos actualizados correctamente.",
        state: "success",
        duration: 5,
      })
    );
    dispatch(importUpdateNeeded({ value: true }));
  } else if (result?.error) {
    dispatch(
      importAlertState({
        content: i18n.t("documents:alerts.operationError"),
        state: "error",
        duration: 10,
      })
    );
  }
};

export const restoreInitialBalance = async (
  dispatch,
  importAlertState,
  element,
  settleTaxDocument,
  documentsDic,
  importUpdateNeeded,
  { total }
) => {
  dispatch(
    importAlertState({
      content: `Estamos actualizando su información (${total} DTE)`,
      state: "loading",
      duration: 10,
    })
  );
  const id = element?.id;
  const result = await settleTaxDocument({
    id,
    input: {
      amount: element?.montoTotal,
      companyId: element?.companyId,
      currencyType: element?.currencyType,
      documentDate: element?.fechaEmision,
      documentType: element?.documentType,
      isManual: element?.isManual,
      meta: {
        documentCode: documentsDic[element?.tipo]?.name,
        documentId: element?.folio,
        dueDate: element?.dueDate,
        inform: {
          amountInform: element?.amountInform,
          informDate: element?.informDate,
          isInform: element?.isInform,
          remaining: element?.informRemaining,
        },
        isPaid: false,
        isReceived: element?.recibido,
        issuedAt: element?.issuedAt,
        issuerId: element?.rutEmisor,
        issuerName: element?.emisor,
        netAmount: element?.netAmount,
        originalAmount: element?.originalAmount,
        otherTaxes: element?.otherTaxes,
        paymentDate: null,
        receiverId: element?.rutReceptor,
        receiverName: element?.receptor,
        remaining: element?.originalAmount,
        summary: element?.summary,
        taxAmount: element?.taxAmount,
        taxRate: parseFloat(element?.taxRate),
      },
    },
  });
  if (result?.data) {
    dispatch(
      importAlertState({
        content: "Datos actualizados correctamente.",
        state: "success",
        duration: 5,
      })
    );
    dispatch(importUpdateNeeded({ value: true }));
  } else if (result?.error) {
    dispatch(
      importAlertState({
        content: i18n.t("documents:alerts.operationError"),
        state: "error",
        duration: 10,
      })
    );
  }
};

export const deleteMultipleDocuments = async (
  ids,
  total,
  deleteDocuments,
  dispatch,
  importAlertState,
  importUpdateNeeded,
  companyId,
  setSelectedDocuments
) => {
  dispatch(
    importAlertState({
      content: `Estamos actualizando su información (${total} documento(s))`,
      state: "loading",
      duration: 10,
    })
  );

  const input = ids.map((id) => ({ id, recurringId: "" }))

  const result = await deleteDocuments({ companyId, input });

  if (result?.data) {
    dispatch(
      importAlertState({
        content: i18n.t("documents:alerts.documentDeleted"),
        state: "success",
        duration: 5,
      })
    );
    dispatch(importUpdateNeeded({ value: true }));
    dispatch(setSelectedDocuments([]));
  } else if (result?.error) {
    dispatch(
      importAlertState({
        content: i18n.t("documents:alerts.operationError"),
        state: "error",
        duration: 10,
      })
    );
  }

}

export const deleteDteFunction = async (
  dispatch,
  importAlertState,
  { total },
  element,
  deleteTaxDocument,
  importUpdateNeeded
) => {
  dispatch(
    importAlertState({
      content: `Estamos actualizando su información (${total} DTE)`,
      state: "loading",
      duration: 10,
    })
  );
  const id = element?.id;
  const result = await deleteTaxDocument({
    id,
  });
  if (result?.data) {
    dispatch(
      importAlertState({
        content: i18n.t("documents:alerts.documentDeleted"),
        state: "success",
        duration: 5,
      })
    );
    dispatch(importUpdateNeeded({ value: true }));
  } else if (result?.error) {
    dispatch(
      importAlertState({
        content: i18n.t("documents:alerts.operationError"),
        state: "error",
        duration: 10,
      })
    );
  }
};
